export default __webpack_public_path__ + "static/media/gf.5fc814b1.svg";